import React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'semantic-ui-react'
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import InputField from '../components/InputField'
import { getUserId, getIpAddress } from '../../redux'
// import send_message_btn_mobile from '../../img/send-message-btn-mobile.png'
import send_message_btn_mobile_gray from '../../img/send-message-btn-mobile-gray.png'

const UserInput = ({
  handleSubmit,
  sendMessage,
  userId,
  ipAddress,
}) => {

  function onFieldChange(value) {
    if (document.getElementsByClassName('desktop-submit')[0]) {
      var fieldValue = document.getElementsByName('userMessage')[0].value;

      if (fieldValue.length > 0) {

        document.getElementsByClassName('desktop-submit')[0].getElementsByTagName('button')[0].style.backgroundColor = '#24BB9C';
        // document.getElementsByClassName('mobile-submit')[0].getElementsByTagName('button')[0].style.backgroundImage = `url(${send_message_btn_mobile})`;
      }
      else {
        document.getElementsByClassName('desktop-submit')[0].getElementsByTagName('button')[0].style.backgroundColor = '#CACACA';
        document.getElementsByClassName('mobile-submit')[0].getElementsByTagName('button')[0].style.backgroundImage = `url(${send_message_btn_mobile_gray})`;
      }
    }
  }

  const onSubmit = (data) => {
    const params = {
      type: 'message',
      from: {
        id: userId,
        ipAddress,
      },
    };
    const formatedMessage = { ...params, text: data.userMessage }
    sendMessage(data.sessionToken, formatedMessage, data.conversationId)
    window.setTimeout(() => {
      document.getElementsByClassName('desktop-submit')[0].getElementsByTagName('button')[0].style.backgroundColor = '#CACACA';
      document.getElementsByClassName('mobile-submit')[0].getElementsByTagName('button')[0].style.backgroundImage = `url(${send_message_btn_mobile_gray})`;
    }, 50)
  };



  return (
    <Form onSubmit={handleSubmit(onSubmit)} autoComplete="off" className="user-input">
      <Form.Group>
        <div className="user-input-text">
          <Field
            name="userMessage"
            id="user-message"
            label="Cliquez ici pour écrire quelque chose..."
            component={InputField}
            type="text"
            onChange={onFieldChange(this.value)}
            validateWithEnter={handleSubmit(onSubmit)}
            style={{ backgroundColor: '#24BB9C', color: 'white', border: 'none' }}
          />
        </div>
        <Form.Button
          style={{ 
            backgroundImage: `url(${send_message_btn_mobile_gray})`,
            width: '44px',
            backgroundColor: 'transparent',
            height: '44px',
            backgroundSize: '50%',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center'
          }}
          content=""
          type="submit"
          className="mobile-submit" 
        />
        <Form.Button
          style={{ 
            backgroundColor: '#CACACA',
            boxShadow: '0 6px 7px 0 rgba(0, 0, 0, 0.14)',
            color: 'white',
            textTransform: 'uppercase',
            letterSpacing: 0.94,
            fontSize: '10pt',
            fontFamily: 'BNPP Sans Regular, sans-serif'
          }}
          content="Envoyer"
          type="submit"
          className="desktop-submit"
        />
      </Form.Group>
    </Form>
    )
};

UserInput.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  sendMessage: PropTypes.func.isRequired,
  userId: PropTypes.string,
  ipAddress: PropTypes.string.isRequired,
};

const ConnectedUserInput = connect(
  state => ({ userId: getUserId(state), ipAddress: getIpAddress(state) }),
  null,
  )(UserInput);

  export default reduxForm({
    form: 'userInput',
    enableReinitialize: true,
  })(ConnectedUserInput)



// WEBPACK FOOTER //
// ./src/views/layouts/UserInput.js